import React from 'react';
import './PhoneShot.scss';

interface PhoneShotProps {
    shot: number;
    alt: string;
    // Show only the phone, without the App Store caption and background.
    crop?: boolean;
    priority?: boolean;
    className?: string;
}

const PhoneShot: React.FC<PhoneShotProps> = ({ shot, alt, crop = false, priority = false, className = '' }) => {
    // Cropped versions are trimmed to the phone frame (500x1052 / 1000x2104).
    const base = crop ? `/images/shiftwave/ios/phone0${shot}` : `/images/shiftwave/ios/0${shot}`;
    const [w, h] = crop ? [500, 1052] : [600, 1304];
    return (
        <div className={`phone-shot${crop ? ' phone-shot--crop' : ''} ${className}`}>
            <img
                src={`${base}.jpg`}
                srcSet={`${base}.jpg ${w}w, ${base}@2x.jpg ${w * 2}w`}
                sizes="(max-width: 600px) 80vw, 400px"
                width={w}
                height={h}
                alt={alt}
                loading={priority ? 'eager' : 'lazy'}
                decoding="async"
                fetchPriority={priority ? 'high' : 'auto'}
            />
        </div>
    );
};

export default PhoneShot;
